import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyTwoNoDownloadPreLogin',
    name: 'IFPageOneHSixtyTwoNoDownloadPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyTwoNoDownloadLogin' ||
        from.path === '/IFPageOneHSixtyTwoNoDownloadLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadLogin',
    name: 'pageOneHSixtyTwoNoDownloadLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadLoginLoading',
    name: 'pageOneHSixtyTwoNoDownloadLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadLeaveInfo',
    name: 'pageOneHSixtyTwoNoDownloadLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadResult',
    name: 'pageOneHSixtyTwoNoDownloadResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadLoading',
    name: 'pageOneHSixtyTwoNoDownloadLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadLoginSecond',
    name: 'pageOneHSixtyTwoNoDownloadLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadBlank',
    name: 'pageOneHSixtyTwoNoDownloadBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyTwoNoDownloadNoProducts',
    name: 'pageOneHSixtyTwoNoDownloadNoProducts',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwoNoDownload/noProducts.vue'),
    meta: {
      title: projectName,
    },
  },
];
